//+ Jonas Raoni Soares Silva
//@ http://raoni.org

class NumericDirective {
    constructor(input, binding) {
        Object.assign(this, { input, binding })
        input.addEventListener('keydown', this)
    }

    handleEvent(event) {
        this[event.type](event)
    }

    keydown(event) {
        const { target, key, keyCode, ctrlKey, metaKey } = event
        if (
            !(
                (key >= '0' && key <= '9') ||
                (key === '-' && !this.binding.modifiers.unsigned && !~target.value.indexOf(key)) ||
                [
                    'Delete',
                    'Backspace',
                    'Tab',
                    'Esc',
                    'Escape',
                    'Enter',
                    'Home',
                    'End',
                    'PageUp',
                    'PageDown',
                    'Del',
                    'Delete',
                    'Left',
                    'ArrowLeft',
                    'Right',
                    'ArrowRight',
                    'Insert',
                    'Up',
                    'ArrowUp',
                    'Down',
                    'ArrowDown',
                ].includes(key) ||
                // ctrl+a, c, x, v
                ((ctrlKey || metaKey) && [65, 67, 86, 88].includes(keyCode))
            )
        ) {
            event.preventDefault()
        }
    }
}

export default {
    beforeMount(el, binding) {
        if (!binding.hasOwnProperty('value') || binding.value) {
            el = el instanceof HTMLInputElement ? el : el.querySelector('input')
            if (el) {
                return new NumericDirective(el, binding)
            }
        }
    },
}
